export enum LogLevel {
    DEBUG = 0,
    INFO = 1,
    WARNING = 2,
    ERROR = 3,

    NEVER = Number.MAX_SAFE_INTEGER,
}
